<div class="container">
    <div class="container navbar-class fixed-top">
        <app-nav-return></app-nav-return>
    </div>

    <div class="d-flex" style="margin-top: 60px;">
        <app-return-side [returnItem]="item" #returnRight [side]="LensSide.RIGHT" [style.visibility]="isRightSideEnable ? 'visible': 'hidden'" (switchEmit)="switch($event)" class="return-side"></app-return-side>
        <div class="delimiter-return"></div>
        <app-return-side [returnItem]="item" #returnLeft [side]="LensSide.LEFT" [style.visibility]="isLeftSideEnable ? 'visible': 'hidden'" (switchEmit)="switch($event)" class="return-side"></app-return-side>
    </div>

    <div class="footer"></div>

    <div class="d-flex action-container">
        <button mat-flat-button color="primary" class="action-button" (click)="print()">{{"home.orders.print" | translate}}</button>
        <button mat-flat-button color="primary" class="action-button" (click)="createRequest()">{{"return.createRequest" | translate}}</button>
    </div>

</div>
